export default {"src":"/_next/static/media/pending-action.7ac6600a.svg","height":28,"width":28};